var _circle, _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#1847CA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 14,
    height: 16,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7109 15.1152C15.7109 14.8581 15.6475 14.6562 15.5205 14.5098C15.3936 14.3633 15.1706 14.2249 14.8516 14.0947C14.5326 13.9645 14.238 13.8327 13.9678 13.6992C13.6976 13.5658 13.4648 13.4111 13.2695 13.2354C13.0742 13.0596 12.9245 12.8561 12.8203 12.625C12.7161 12.3939 12.6641 12.1139 12.6641 11.7852C12.6641 11.235 12.8496 10.7826 13.2207 10.4277C13.5918 10.0697 14.0866 9.86133 14.7051 9.80273V8.77246H15.4814V9.82227C16.0771 9.91016 16.5443 10.1559 16.8828 10.5596C17.2246 10.96 17.3955 11.4694 17.3955 12.0879H15.7451C15.7451 11.7493 15.68 11.4889 15.5498 11.3066C15.4196 11.1243 15.234 11.0332 14.9932 11.0332C14.7783 11.0332 14.6107 11.1016 14.4902 11.2383C14.373 11.3717 14.3145 11.5573 14.3145 11.7949C14.3145 12.0358 14.3828 12.2279 14.5195 12.3711C14.6562 12.5111 14.876 12.6462 15.1787 12.7764C15.4814 12.9033 15.7663 13.0368 16.0332 13.1768C16.3034 13.3135 16.5361 13.4697 16.7314 13.6455C16.9268 13.8213 17.0798 14.0264 17.1904 14.2607C17.3011 14.4951 17.3564 14.7767 17.3564 15.1055C17.3564 15.6621 17.179 16.1162 16.8242 16.4678C16.4727 16.8193 15.9925 17.0244 15.3838 17.083V18.0645H14.6074V17.0781C13.8978 17.0033 13.3525 16.7607 12.9717 16.3506C12.5941 15.9372 12.4053 15.3936 12.4053 14.7197H14.0508C14.0508 15.0908 14.1322 15.374 14.2949 15.5693C14.4609 15.7614 14.6953 15.8574 14.998 15.8574C15.2194 15.8574 15.3936 15.7923 15.5205 15.6621C15.6475 15.5286 15.7109 15.3464 15.7109 15.1152Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 19,
    width: 6,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionManagement);
export default __webpack_public_path__ + "static/media/subscription-management.96b8bc78cd6226f42103395c0ae372a8.svg";
export { ForwardRef as ReactComponent };